import PropTypes from "prop-types";
import React, { useEffect, useState } from "react"
import { Row, Col, CardBody, Card, Progress } from "reactstrap"
import { withRouter, Link } from "react-router-dom";

import { connect } from "react-redux";
import { getProfile } from '../../store/auth/profile/actions';

//Import Components
import LineChart from "./line-chart"
import RevenueChart from "./revenue-chart"
import SalesAnalytics from "./sales-analytics"
import ScatterChart from "./scatter-analytics"
import LatestTransaction from "./latest-transaction"

//Import Image
import widgetImage from "../../assets/images/widget-img.png"
import Overview from "./Overview";
import Reviews from './Reviews';
import Revenue from './Revenue';
import Inbox from './Inbox';
import { get, post } from "../../helpers/api_helper";
import Utils from "../Utility";

const Dashboard = (props) => {
  const { user } = props;
  const [data, setData] = useState({ source: [], dealers: [], moderator: [] });

  useEffect(() => {
    // console.log('props on home ', user);
    if (user) {
      getStats();
    }
  }, [user]);

  const getStats = () => {
    // console.log('calling get stat');
    get("/stat?companyId=" + user?.companyId, { token: user?.token })
      .then(json => {
        // console.log('response from get stat', json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch(error => {
        console.error('Error while getting stat', error);
      })
  }


  return (
    <React.Fragment>
      <div className="page-content">

        <Row>
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="page-title mb-0 font-size-18">Dashboard</h4>

              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">Welcome to {Utils.projectName} Dashboard</li>
                </ol>
              </div>

            </div>
          </div>
        </Row>

        <Row>
          <Col lg={3}>
            <Card>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-calendar-check"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-16 mt-2">New Leads</div>
                  </div>
                </div>
                <h4 className="mt-4">{data?.newLead?.count ? data?.newLead?.count : 0}</h4>
                <div className="row">
                  <div className="col-7">
                    <p className="mb-0"><span className="text-success me-2"> {data?.newLead?.percent ? data?.newLead?.percent : 0}% <i
                      className="mdi mdi-arrow-up"></i> </span></p>
                  </div>
                  <div className="col-5 align-self-center">

                    <Progress
                      value="62"
                      color="primary"
                      className="bg-transparent progress-sm"
                      size="sm"
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-account-multiple-outline"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-16 mt-2">New Users</div>

                  </div>
                </div>
                <h4 className="mt-4">2,456</h4>
                <Row>
                  <div className="col-7">
                    <p className="mb-0"><span className="text-success me-2"> 0.16% <i
                      className="mdi mdi-arrow-up"></i> </span></p>
                  </div>
                  <div className="col-5 align-self-center">
                    <Progress
                      value="62"
                      color="success"
                      className="bg-transparent progress-sm"
                      size="sm"
                    />
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col lg={9}>
            <LineChart leads={data?.leads} />
          </Col>
        </Row>
        <Row>
          <Col lg={9}>
            <RevenueChart dealers={data?.dealers} />
          </Col>
          <Col lg={3}>
            <Card className="bg-primary" style={{ height: 342 }}>
              <CardBody>
                <div className="text-white">
                  <h5 className="text-white">2400 + New Users</h5>
                  <p>At vero eos et accusamus et iusto odio dignissimos ducimus</p>
                  <div>
                    <Link to="#" className="btn btn-outline-success btn-sm">View more</Link>
                  </div>
                </div>
                <Row className="justify-content-end">
                  <div className="col-8">
                    <div className="mt-4">
                      <img src={widgetImage} alt=""
                        className="img-fluid mx-auto d-block" />
                    </div>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>
          {/* <Col lg={3}>
            <Inbox />
          </Col> */}
        </Row>
        <Row>
          <Col lg={8}>
            <SalesAnalytics source={data?.source} />
          </Col>
          {/* <Col lg={4}>
            <ScatterChart />
          </Col> */}
          <Col lg={4}>
            <Inbox dealers={data?.dealers} />
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <Inbox moderator={data?.moderator} />
          </Col>
          {/* <Reviews /> */}
          <Revenue />
        </Row>

        <Row>
          <LatestTransaction user={user} history={props?.history} />
        </Row>

      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  getProfile: PropTypes.func
}

const mapStateToProps = state => {
  // console.log('state at dashboard', state);
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStateToProps, { getProfile })(Dashboard)
)